module.exports = __webpack_public_path__ + "static/media/android_logo_purple_dark.532beaf2.svg";